export default __webpack_public_path__ + "2cf82d863f907701f2b373742fb10ac2.png";